import Head from 'next/head';
import Post from 'src/views/Marketing/Company/memos/2021-12-19-small-seller-pricing-and-removing-weekly-billing';

export default function Example() {
  return (
    <>
      <Head>
        <title>Memo: $8/mo for small sellers & removing weekly billing</title>
        <meta property='og:title' content='Memo: $8/mo for small sellers & removing weekly billing' />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-12-19T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-12-19T00:00:00.000Z' />
        <meta property='article:tag' content='Memo' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
